import { FunctionComponent, useEffect } from "react";
import history from "./history";

interface PromptProps {
  when: boolean;
  message: string;
}

const Prompt: FunctionComponent<PromptProps> = ({ when, message }) => {
  useEffect(() => {
    const unblock = history.block((transition) => {
      if (confirm(message)) {
        unblock();
        transition.retry();
      }
    });

    if (!when) {
      unblock();
    }

    return unblock;
  }, [when, message]);

  return null;
};

export default Prompt;
